export const setData = (data) => {
    if (!data) return { items: [], isLoaded: false };
    return { items: data, isLoaded: true };
};

export const hasVideoKeyInPayload = (payload, key) => {
    if (!payload) return false;
    if (
        !payload.video ||
        !payload.video.data ||
        !payload.video.data.hasOwnProperty(key)
    ) {
        return false;
    }
    return true;
};
